import styled from "styled-components";
import Popover from "@material-ui/core/Popover";
import { MUITheme } from "../../../AppTheme.styled";

export const StyledProfile = styled.div`
  display: flex;
  justify-content: flex-end;

  .profileContainer {
    display: flex;
    align-items: center;
    margin: 32px 0;
    cursor: pointer;

    > .profileName {
      margin-left: 8px;
      display: flex;
      align-items: center;
      line-height: 1;

      svg {
        margin-left: 16px;
        color: ${({ theme }) => theme.palette.neutral3};
      }
    }

    &.isOpen {
      > .profileName {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  ${MUITheme.breakpoints.down("sm")} {
    display: none;
  }
`;

export const StyledPopover = styled(Popover)`
  .MuiPopover-paper {
    margin-top: 16px;
    border-radius: 10px;
    box-shadow: 0px 4px 6px -1px rgba(26, 32, 44, 0.1),
      0px 2px 4px -1px rgba(26, 32, 44, 0.06);

    .profileMenu {
      padding: 16px 0;
    }
  }
`;
